function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.initFlavourListeners();
  }

  initFlavourListeners() {
    const flavourRadios = this.querySelectorAll('input[type="radio"][name="Flavour"]');
  
    flavourRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        const newFlavour = radio.value;
        this.onFlavourChange(newFlavour);
      });
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    console.log('Selected options:', this.options);

    const variants = this.getVariantData();

    // Try to find an exact match first
    this.currentVariant = variants.find((variant) => {
      return variant.options.every((option, index) => this.options[index] === option);
    });

    // Fallback: if no exact match, match flavour (option[0]) and return first available
    if (!this.currentVariant && this.options?.[0]) {
      const selectedFlavour = this.options[0];

      this.currentVariant = variants.find((variant) => {
        return variant.options[0] === selectedFlavour;
      });

      if (this.currentVariant) {
        // Update options to match the fallback variant so dropdowns reflect it
        this.options = [...this.currentVariant.options];

        // Update the quantity <select> UI to reflect the new selection
        const selects = this.querySelectorAll('select');
        this.currentVariant.options.forEach((opt, index) => {
          if (selects[index]) selects[index].value = opt;
        });
      }
    }

    if (!this.currentVariant) {
      console.warn('No matching variant found — even for selected flavour:', this.options?.[0]);
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
  
        // Update price
        const priceId = `price-${this.dataset.section}`;
        const priceDestination = document.getElementById(priceId);
        const priceSource = html.getElementById(priceId);
        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.classList.remove('visibility-hidden');
        }

        // Update Discount
          const discountId = `discount-${this.dataset.section}`;
          const discountDestination = document.getElementById(discountId);
          const discountSource = html.getElementById(discountId);
    
          if (discountSource && discountDestination) {
            discountDestination.innerHTML = discountSource.innerHTML;
          }

        // Update variant-specific images
          const imageContainerId = `product-media-icons-${this.dataset.section}`;
          const imageContainerDestination = document.getElementById(imageContainerId);
          const imageContainerSource = html.getElementById(imageContainerId);
          
          if (imageContainerSource && imageContainerDestination) {
            imageContainerDestination.innerHTML = imageContainerSource.innerHTML;
          }

        // Update Product Title
        const titleId = `product-title-${this.dataset.section}`;
        const titleDestination = document.getElementById(titleId);
        const titleSource = html.getElementById(titleId);
    
        if (titleSource && titleDestination) {
          titleDestination.innerHTML = titleSource.innerHTML;
        }

        // Update Quantity Dropdown
        const quantityId = `product-quantity-${this.dataset.section}`;
        const quantityDestination = document.getElementById(quantityId);
        const quantitySource = html.getElementById(quantityId);
        
        if (quantitySource && quantityDestination) {
          quantityDestination.innerHTML = quantitySource.innerHTML;
        }
  
        // Update ingredients for desktop
        const ingredientsDesktopId = `ingredients-desktop-${this.dataset.section}`;
        const ingredientsDesktopDestination = document.getElementById(ingredientsDesktopId);
        const ingredientsDesktopSource = html.getElementById(ingredientsDesktopId);
        if (ingredientsDesktopSource && ingredientsDesktopDestination) {
          ingredientsDesktopDestination.innerHTML = ingredientsDesktopSource.innerHTML;
          ingredientsDesktopDestination.classList.remove('visibility-hidden');
        }
        
        // Update ingredients for mobile
        const ingredientsMobileId = `ingredients-mobile-${this.dataset.section}`;
        const ingredientsMobileDestination = document.getElementById(ingredientsMobileId);
        const ingredientsMobileSource = html.getElementById(ingredientsMobileId);
        if (ingredientsMobileSource && ingredientsMobileDestination) {
          ingredientsMobileDestination.innerHTML = ingredientsMobileSource.innerHTML;
          ingredientsMobileDestination.classList.remove('visibility-hidden');
        }

        // Update selected price
        const priceIdVariant = `selected-price-${this.dataset.section}`;
        const priceDestinationVariant = document.getElementById(priceIdVariant);
        const priceSourceVariant = html.getElementById(priceIdVariant);
        if (priceSourceVariant && priceDestinationVariant) {
          priceDestinationVariant.innerHTML = priceSourceVariant.innerHTML;
        }

        // Update tagline
        const taglineId = `tagline-${this.dataset.section}`;
        const taglineDestination = document.getElementById(taglineId);
        const taglineSource = html.getElementById(taglineId);
        if (taglineSource && taglineDestination) {
          taglineDestination.innerHTML = taglineSource.innerHTML;
        }

        const dropdownId = `custom-dropdown-${this.dataset.section}`;
        const dropdownDestination = document.getElementById(dropdownId);
        const dropdownSource = html.getElementById(dropdownId);
        console.log(dropdownSource);
        if (dropdownSource && dropdownDestination) {
          dropdownDestination.innerHTML = dropdownSource.innerHTML;
        }

        initializeDropdown();
  
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
    }

    if (!modifyClass) return;
  }

  onFlavourChange(newFlavour) {
    const variants = JSON.parse(this.dataset.variants);
    const matchingVariants = variants.filter(v => v.option1 === newFlavour);

    if (!matchingVariants.length) return;

    const firstVariant = matchingVariants[0];
    this.currentVariant = firstVariant;


    // Update URL early
    this.updateURL();

    this.renderProductInfo(); // Trigger update
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/*  init */
// const observer = ('.', {
// rootMargin: '10px 0px', // syntax similar to that of CSS Margin
// threshold: 0.1 // ratio of element convergence
// });
//  observer.observe();
document.addEventListener('click', function (e) {

  /* TRIGGER CLICK */
  const trigger = e.target.closest('.quick-select-trigger');
  if (trigger) {
    e.preventDefault();
    const panel = trigger.previousElementSibling;
    if (!panel || !panel.classList.contains('variant-quick-select')) return;

    panel.classList.toggle('is-open');
    return;
  }

  /* CLICK INSIDE PANEL */
  const panel = e.target.closest('.variant-quick-select.is-open');
  if (panel) {
    // Identify the specific link or item clicked
    const clickedItem = e.target.closest('a[data-instant-action-type="add-to-instant-cart"]'); // Using 'a' as requested
    
    if (clickedItem) {
      clickedItem.classList.add('is-clicked');
    }

    // Close panel and then cleanup
    requestAnimationFrame(() => {
       setTimeout(() => {
      panel.classList.remove('is-open');
       }, 700); // Match this to your CSS transition time
      
      // Remove the class after the panel is closed 
      // (Optionally wrap in setTimeout if you have a long CSS transition)
      setTimeout(() => {
  if (clickedItem) clickedItem.classList.remove('is-clicked');
      }, 1050); // Match this to your CSS transition time
    });
  }

}, true);

document.querySelectorAll('[data-scroll-to]').forEach(element => {
  element.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('data-scroll-to');
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

 
(function() {
  const originalFetch = window.fetch;
  const originalAssign = window.location.assign;
  const originalReplace = window.location.replace;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    // If it's a 422 error from the cart
    if (response.status === 422 && args[0].includes('/cart/add')) {
      console.log("422 Detected: Silently disabling redirect functions...");

      // 1. Overwrite the redirect methods with "empty" functions
      window.location.assign = function() { return false; };
      window.location.replace = function() { return false; };

      // 2. If they use location.href = '/cart', we can't overwrite it, 
      // but we can try to "freeze" the window 
      window.addEventListener('beforeunload', (e) => {
          // We don't call e.preventDefault() here to avoid the "Leaving site?" popup
          window.stop(); 
      }, { once: true });

      // 3. Restore everything back to normal after 3 seconds
      // This allows the user to navigate manually later
      setTimeout(() => {
        window.location.assign = originalAssign;
        window.location.replace = originalReplace;
        console.log("Navigation functions restored.");
      }, 3000);
    }
    return response;
  };
})();

// // Automatisch toevoegen van FREE GIFT — versie voor de Instant cart
// (() => {
//   // ══════════════════════════════════════════════════════════════
//   //  CONFIG — moet gelijk zijn aan de waarden bovenaan de cart-code
//   // ══════════════════════════════════════════════════════════════
//   const BE_HOSTS = ['stelz.be', 'www.stelz.be', 'drinkstelz.be', 'www.drinkstelz.be'];

//   const host  = (location.hostname || '').toLowerCase();
//   const IS_BE = host.endsWith('.be') || BE_HOSTS.includes(host);

//   const GIFT_VARIANT_ID = IS_BE ? 57302479864132 : 56883439337796;
//   const MODE      = IS_BE ? 'cents' : 'trays';
//   const STEP      = IS_BE ? 4900 : 6;      // €49,00 per sok  |  6 trays
//   const MIN_CENTS = IS_BE ? 0 : 11610;     // == nl_socks_value (6 × €19,35, de 0.0-tray)

//   // .com-sokkenactie staat UIT — zelfde stand als in de cart (nl_gift_ok = false).
//   // Met 0 wordt `want` op .com altijd 0: er komt geen sok bij, en een eerder
//   // toegevoegde cadeau-sok wordt opgeruimd.
//   // ⇒ Gaat de actie live? Zet deze 0 op 1 en zet in de cart de sokken-trap terug aan.
//   const MAX_QTY   = IS_BE ? 10 : 0;

//   const DEBOUNCE_MS = 250;
//   const RETRY_MS    = 800;
//   const MAX_WAIT    = 15;
//   const MAX_FAILS   = 3;
//   // ══════════════════════════════════════════════════════════════

//   let running = false, queued = false, selfMutating = false, timer = null, waits = 0, fails = 0;
//   const api = () => window.Instant && window.Instant.api;

//   const netPrice   = i => Number(i.final_line_price ?? i.line_price ?? 0);
//   const grossPrice = i => Number(i.original_line_price ?? i.line_price ?? 0);

//   // Statiegeld telt NOOIT als tray — zelfde regel als in de cart-code.
//   const isFeeLine = i => {
//     const t = ((i.product_title || '') + ' ' + (i.title || '') + ' ' + (i.handle || '')).toLowerCase();
//     return t.includes('statiegeld') || t.includes('product-fees');
//   };

//   // Cadeau-regel: markering OF €0. De markering blijft staan als de prijs terugspringt
//   // doordat er een ordekorting bijkomt — daarom is de prijs alleen niet genoeg.
//   const isGiftLine = i => Number(i.variant_id) === GIFT_VARIANT_ID &&
//     (IS_BE || (i.properties && i.properties._free_gift) || netPrice(i) === 0);

//   // 12-pack = 1 tray, 24-pack = 2 trays.
//   const trayCount = items => items.reduce((sum, i) => {
//     if (isFeeLine(i)) return sum;
//     const probe = ((i.variant_title || '') + ' ' + (i.product_title || '') + ' ' + (i.title || '')).toLowerCase();
//     if (probe.includes('24')) return sum + i.quantity * 2;
//     if (probe.includes('12')) return sum + i.quantity;
//     return sum;
//   }, 0);

//   async function sync() {
//     const a = api();
//     if (!a) { if (waits++ < MAX_WAIT) setTimeout(sync, RETRY_MS); return; }
//     if (running) { queued = true; return; }
//     running = true; queued = false;

//     try {
//       const cart  = await a.getCart();
//       const items = (cart && cart.items) || [];

//       const giftLines = items.filter(isGiftLine);
//       const eligible  = items.filter(i => !isGiftLine(i));

//       // Alles op de BRUTOPRIJS. Shopify beoordeelt de minimumvereiste van een
//       // automatische korting vóór korting, en de cart rekent zijn drempels sinds de
//       // laatste wijziging ook op original_line_price — óók de BE-drempel. Met de
//       // nettoprijs eet een toegepaste korting zijn eigen voorwaarde op: het bedrag
//       // zakt, de drempel valt weg, en dan haalt het script de sok juist weer weg.
//       const gross = eligible.reduce((s, i) => s + grossPrice(i), 0);
//       const basis = MODE === 'trays' ? trayCount(eligible) : gross;

//       let want = Math.min(Math.floor(basis / STEP), MAX_QTY);
//       if (gross < MIN_CENTS) want = 0;

//       const have = giftLines.reduce((s, i) => s + Number(i.quantity || 0), 0);
//       if (have === want && giftLines.length <= 1) { fails = 0; return; }

//       selfMutating = true;
//       if (want === 0) {
//         // Alleen ECHTE cadeau-regels opruimen; een gekochte sok blijft staan.
//         for (const g of giftLines) await a.updateLine(g.key, { quantity: 0 });
//       } else if (giftLines.length === 0) {
//         await a.addToCart(
//           { id: GIFT_VARIANT_ID, quantity: want, properties: { _free_gift: 'yes' } },
//           { openCart: false }
//         );
//       } else {
//         if (Number(giftLines[0].quantity) !== want) await a.updateLine(giftLines[0].key, { quantity: want });
//         for (let i = 1; i < giftLines.length; i++) await a.updateLine(giftLines[i].key, { quantity: 0 });
//       }
//       fails = 0;
//     } catch (err) {
//       console.warn('[gift]', err);
//       if (fails++ < MAX_FAILS) queued = true;
//     } finally {
//       selfMutating = false;
//       running = false;
//       if (queued) { queued = false; setTimeout(sync, RETRY_MS); }
//     }
//   }

//   function schedule(ms = DEBOUNCE_MS) { clearTimeout(timer); timer = setTimeout(sync, ms); }

//   // Cart-mutaties opmerken. Eigen mutaties negeren, anders ontstaat een lus.
//   const isCartUrl = u => /\/cart\/(add|change|update|clear)|\/cart\.js/.test(String(u || ''));
//   const _fetch = window.fetch;
//   window.fetch = async function (input, init) {
//     const res = await _fetch.apply(this, arguments);
//     const url = typeof input === 'string' ? input : (input && input.url) || '';
//     if (isCartUrl(url) && !selfMutating) schedule();
//     return res;
//   };
//   const _XHR = window.XMLHttpRequest;
//   window.XMLHttpRequest = function () {
//     const xhr = new _XHR(), _open = xhr.open.bind(xhr);
//     xhr.open = function (m, url) { xhr.__url = url; return _open(m, url); };
//     xhr.addEventListener('loadend', () => {
//       if (isCartUrl(xhr.__url) && !selfMutating) schedule();
//     });
//     return xhr;
//   };

//   schedule(600);
//   window.__giftSync = () => sync();
// })();